import React from "react";
import AccessControlList from "../accessControl/AccessControlList";
import {
  IAccessControlUserPageProps,
  IAccessControlPageState,
} from "../../../interfaces/Index";
import HeadingText from "../../common/HeadingText/HeadingText";
import AddUpdateAccessControlPage from "./AddUpdateAccessControlPage";

export default class AccessControlPage extends React.Component<
  IAccessControlUserPageProps,
  IAccessControlPageState
> {
  constructor(props: IAccessControlUserPageProps) {
    super(props);
    this.state = {
      isEdit: false,
      showAddUpdatePage: false,
      selectedAccessControlUser: null,
      isAccessControlUserAddUpdate: false,
      searchText: "",
      currentListPosition: 0,
      passwordReset: "",
    };
  }

  renderAddUpdateAccessControlPage = () => {
    const { isEdit, selectedAccessControlUser } = this.state;
    const {
      getAccessControlUserDetailsNew,
      updateAccessControlUser,
      clearAccessControlUserLevelDetails,
      accessControlUserDetailsNew,
      isLoading,
      isError,
      error,
      getAllRolesAndClients,
      allClientsRoles,
      isAllClientsRolesFetched,
      createAccessControlUserWithClientAndRoles,
      updateAccessControlUserWithClientAndRoles,
      userInfo,
      filters,
      isAllFiltersFetched,
      fetchAllFilters
    } = this.props;
    return (
      <AddUpdateAccessControlPage
        {...this.props}
        accessControlUser={selectedAccessControlUser}
        isEdit={isEdit}
        getAccessControlUserDetailsNew={getAccessControlUserDetailsNew}
        backButtonHandler={this.navigateBackToListingPage}
        clearAccessControlUserLevelDetails={clearAccessControlUserLevelDetails}
        accessControlUserDetailsNew={accessControlUserDetailsNew}
        isLoading={isLoading}
        isError={isError}
        error={error}
        getAllRolesAndClients={getAllRolesAndClients}
        allClientsRoles={allClientsRoles}
        isAllClientsRolesFetched={isAllClientsRolesFetched}
        createUserClientAndRoles={createAccessControlUserWithClientAndRoles}
        updateUserClientAndRoles={updateAccessControlUserWithClientAndRoles}
        userInfo={userInfo}
        filters={filters}
        isAllFiltersFetched={isAllFiltersFetched}
        fetchAllFilters={fetchAllFilters}
      />
    );
  };

  renderAccessControlUserListing = () => {
    const {
      fetchAccessControlUsers,
      accessControlUsers,
      error,
      pagination,
      isAccessControlUserAdded,
      isAccessControlUserUpdated,
      isLoading,
      isError,
      userInfo,
    } = this.props;
    const {
      isAccessControlUserAddUpdate,
      searchText,
      currentListPosition,
      passwordReset,
    } = this.state;
    return (
      <>
        <section className="main-heading-margin">
          <HeadingText text="Access controls" isMainHeading={true} />
        </section>
        <AccessControlList
          fetchAccessControlUsers={fetchAccessControlUsers}
          accessControlUsers={accessControlUsers}
          pagination={pagination}
          isLoading={isLoading}
          isError={isError}
          error={error}
          isAccessControlUserAddedorUpdated={isAccessControlUserAddUpdate}
          addUpdatePageHandler={this.toggleAddUpdateAccessControlUserPage}
          isAccessControlUserAdded={isAccessControlUserAdded}
          isAccessControlUserUpdated={isAccessControlUserUpdated}
          retainedSearchText={searchText}
          currentListPosition={currentListPosition}
          userInfo={userInfo}
          passwordReset={passwordReset}
        />
      </>
    );
  };

  toggleAddUpdateAccessControlUserPage = (
    isEdit: boolean = false,
    selectedAccessControlUser: any = null,
    searchText: string = "",
    currentScroll: number = 0
  ) => {
    const { showAddUpdatePage } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      isEdit: isEdit,
      selectedAccessControlUser: selectedAccessControlUser,
      searchText: searchText,
      currentListPosition: currentScroll,
    });
  };

  navigateBackToListingPage = (isAddUpdate: boolean, passwordReset: any) => {
    const { showAddUpdatePage, searchText, currentListPosition } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      isAccessControlUserAddUpdate: isAddUpdate,
      searchText: isAddUpdate ? "" : searchText,
      currentListPosition: isAddUpdate ? 0 : currentListPosition,
      passwordReset: passwordReset,
    });
  };

  render() {
    const { showAddUpdatePage } = this.state;
    return (
      <div>
        {showAddUpdatePage
          ? this.renderAddUpdateAccessControlPage()
          : this.renderAccessControlUserListing()}
      </div>
    );
  }
}
